export default "/images/vendor/flag-icon-css/flags/1x1/cn.svg?f5a6f048eb8367343bd42fd1895a8c5f";